const accessToken = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')).accessToken : null

export default accessToken
